import getThemeVars from './color.js'

export default {
  name: '默认主题',
  vars: getThemeVars(),
}
